export class ProfileMessages {
  public static readonly EDIT_PROFILE = 'profile.edit-profile';
}
